<template>
  <div class="box-card">
    <el-tabs class="top-tab" type="card" v-model="tab" @tab-click="handleTabChange">
      <el-tab-pane label="web" name="web"></el-tab-pane>
      <el-tab-pane label="h5" name="h5"></el-tab-pane>
      <el-tab-pane label="小程序" name="mini"></el-tab-pane>
    </el-tabs>
    <!-- 表单 -->
    <div class="table-container">
      <div class="top">
        <div class="table-action-row"></div>
        <div>
          <el-button v-if="jurisdiction.pipelineManage" type="primary" @click="changeDefaultJson">
            调整默认配置
          </el-button>
          <el-button type="primary" @click="showCreate = true">新增发布任务</el-button>
        </div>
      </div>
      <!-- 列表 -->
      <el-table :data="list" style="width: 100%" v-loading="loading">
        <el-table-column prop="id" label="ID" />
        <el-table-column prop="app_type" label="平台">
          <template slot-scope="scope">
            {{ PIPELINE_PLATFORM[scope.row.app_type] }}
          </template>
        </el-table-column>
        <el-table-column prop="env" label="环境">
          <template slot-scope="scope">
            {{ PIPELINE_ENV[scope.row.env] }}
          </template>
        </el-table-column>
        <template v-if="tab === 'mini'">
          <el-table-column prop="mini_appid" label="小程序appid" />
          <el-table-column prop="mini_branch" label="小程序分支" />
        </template>
        <el-table-column prop="custom_branch" label="定制分支" />
        <el-table-column prop="artifact_url" label="制品地址" />
        <el-table-column prop="remark" label="备注" />
        <el-table-column prop="create_time" label="创建时间">
          <template slot-scope="scope">
            {{ scope.row.create_time ? formatTime(scope.row.create_time * 1000) : '' }}
          </template>
        </el-table-column>
        <el-table-column prop="build_detail" label="构建日志">
          <template slot-scope="scope">
            {{ formatBuildDetail(scope.row.build_detail) }}
          </template>
        </el-table-column>
        <el-table-column prop="" label="操作" align="center" width="200">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openDetail(scope.row)">详情</el-button>
            <el-button type="text" size="small" @click="stopPipeline(scope.row)">终止</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          :current-page.sync="search.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="search.page_size"
          layout="total, sizes, prev, pager, next"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
    <!-- JSON编辑器 -->
    <json-edit
      v-if="showJsonEdit"
      type="edit"
      :show-json="showJsonEdit"
      :json="editJson"
      title="配置编辑"
      @save="saveJson"
      @cancel="showJsonEdit = false"
    />
    <messageBox ref="messageBox" />
    <createDialog :visible="showCreate" :tab="tab" @submit="publish" @close="showCreate = false" />
    <detailDrawer
      :visible="showDetail"
      :detail="detailData"
      :tab="tab"
      @close="showDetail = false"
    />
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { mapActions, mapGetters } from 'vuex';
import messageBox from '@/components/messageBox';
import { GetKvlist, UpdateKv } from '@/api/kv.js';
import { getPipelineList, startPipeline } from '@/graphql/api/pipeline.js';
import { whereGql } from '@/graphql/util';
import jsonEdit from '@/components/jsonEdit/index.vue';
import createDialog from './create';
import detailDrawer from './detail';
import { PIPELINE_PLATFORM, PIPELINE_ENV } from '@/utils/constant.js';
import axios from 'axios';

const newAxios = axios.create({
  baseURL: '',
  timeout: 600000,
});

export default {
  components: {
    messageBox,
    jsonEdit,
    createDialog,
    detailDrawer,
  },
  data() {
    return {
      PIPELINE_PLATFORM,
      PIPELINE_ENV,
      tab: 'web',
      loading: false,
      search: {
        page: 1,
        page_size: 10,
      },
      total: 0,
      list: [],
      editJson: '',
      editId: '',
      showJsonEdit: false,
      showCreate: false,
      showDetail: false,
      detailData: {},
    };
  },
  computed: {
    ...mapGetters('user', ['getTenantInfo', 'getCurrentEnv', 'getElementList']),
    jurisdiction() {
      return {
        pipelineManage: this.getElementList.includes('pipeline-manage'),
      };
    },
  },
  async created() {
    await this.GetCurrentEnv();
    this.getList();
  },
  mounted() {},
  methods: {
    ...mapActions('user', ['GetCurrentEnv']),
    async getList() {
      this.loading = true;
      try {
        getPipelineList({
          platform: this.tab,
        }).then((res) => {
          this.list = res.mini_program_pipline?._data || [];
          this.total = res.mini_program_pipline?._aggregate.count;
        });
        this.loading = false;
      } catch (err) {
        console.log(err);
        this.loading = false;
      }
    },
    handleSizeChange(value) {
      this.search.page_size = value;
      this.search.page = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.search.page = val;
      this.getList();
    },
    stopPipeline({ id }) {
      newAxios
        .post('https://nges.crmpower.cn/trpc.test.demo.External/StopBuild', {
          id,
        })
        .then(() => {
          this.$message.success('已终止');
          this.getList();
        });
    },
    changeDefaultJson() {
      this.editJson = '';
      GetKvlist({
        limit: 1,
        offset: 0,
        tableName: 'kv',
        filter: whereGql([
          {
            whereGqlType: 'is',
            key: `pipeline_default_json_${this.tab}`,
          },
        ]),
      })
        .then((res) => {
          const kv = res.kv._data[0];
          this.editId = kv.id;
          this.editJson = kv.value;
          this.showJsonEdit = true;
        })
        .catch((e) => {
          console.error(e);
          this.$message.error('获取配置失败');
        });
    },
    publish(data) {
      startPipeline(data).then(() => {
        this.showCreate = false;
        this.$message.success('新增成功');
        this.getList();
      });
    },
    formatTime(time) {
      return dayjs(time).format('YYYY-MM-DD HH:mm:ss');
    },
    handleTabChange() {
      this.getList();
    },
    saveJson(newJson) {
      const gqlStr = (str) => {
        return str.trim().replace(/\\"/g, `\\\\"`).replace(/"/g, `\\"`).replaceAll('\n', '\\n');
      };
      UpdateKv({
        tableName: 'kv',
        id: this.editId,
        value: gqlStr(JSON.stringify(JSON.parse(newJson))),
      }).then(() => {
        this.$message.success('保存成功');
        this.showJsonEdit = false;
        this.editJson = '';
        this.editId = '';
      });
    },
    openDetail(data) {
      this.detailData = data;
      this.showDetail = true;
    },
    formatBuildDetail(list) {
      try {
        const a = list.slice(1, list.length - 1);
        return a.split(',').pop();
      } catch {
        return list;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/element/table.scss';
@import '@/styles/element/input.scss';
@import '@/styles/element/select.scss';
@import '@/styles/element/button.scss';
@import '@/styles/element/pagination.scss';
@import '@/styles/element/tab.scss';

.top-tab {
  margin-top: -20px; // special-style
  margin-left: -20px; // special-style
  margin-right: -20px; // special-style
  padding-left: 16px; // special-style
  padding-right: 16px; // special-style
}
.table-container {
  flex: 1;
  margin: var(--Margin-16) 0;
  padding: var(--Padding-16);
  background: #fff;
}
.top {
  display: flex;
  margin-bottom: var(--Margin-16);
  .table-action-row {
    flex: 1;
    display: flex;
  }
}
</style>
